import React, { useEffect, useState } from "react";
import Joinus from "../../common/Joinus";
import { initialStates, servicesseo, gridsco, seoServiceDetails } from "../home/Constant";
import DigitalSeoAni from "./DigitalSeoAni";
import { AnimatePresence, motion } from "framer-motion";
import WhatWeDo from "./WhatWeDo";

const DigitalSeo = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  const [expandedItems, setExpandedItems] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const toggleContent = () => {
    setExpandedItems(prev => !prev);
  };
  return (
    <div className="margin-topall">
      <section className="py-5 service-position">
        <div className="container">
          <div className="metaseo-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                id={`dot_00${i}`}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-10"
                data-aos="fade-up" data-aos-delay="300"
              >
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2">
                    SEO(Search Engine Optimization) services
                  </h5>
                  {/* <h4 className="black-service-heading text-center font-align mt-3">
                                    Unlock 5x Revenue Growth
                                </h4> */}
                  <div className="smsseo-sub-heading">
                    SEO (Search Engine Optimization) is essential for driving organic traffic 
                    and improving your website’s visibility on search engines. Our SEO services 
                    focus on creating high-ranking, search-engine-friendly websites that attract 
                    relevant visitors, enhance brand credibility, and increase conversions. 
                    From keyword research and on-page optimization to technical audits and 
                    link-building strategies, we help businesses achieve sustainable growth. 
                    Partner with us to leverage proven SEO services that deliver measurable results.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={seoServiceDetails} />
      <DigitalSeoAni />
      <section className="overflow-hidden">
        <div className="container">

          {gridsco.map((item, index) => (
            <div className="row  gridflex" key={index}>
              <div className={`col-lg-6 ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <div className="d-flex gap-2">
                  <div className="circleservice">{index + 1}</div>
                  <h1 className="servicebenefit">{item.heading}</h1>
                </div>
                <div className="servicefontb ">
                  <p className="py-2">{item.para1}</p>
                </div>
                {index === 0 && (
                  <>
                    <AnimatePresence initial={false}>
                      {expandedItems && (
                        <motion.p
                          key="expand-content"
                          className="servicefontb"
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: "auto" }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.4 }}
                        >
                          {item.para2}
                        </motion.p>
                      )}
                    </AnimatePresence>

                    <button className="btn-sm readbtn" onClick={toggleContent}>
                      {expandedItems ? "Read Less" : "Read More"}
                    </button>
                  </>
                )}
              </div>

              <div className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}
                data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
              >
                <img src={item.img} alt={`Visual for ${item.heading}`} className="bulkwidth" />
              </div>
            </div>
          ))}

        </div>
      </section>
      {/* <WhatDo/> */}
      <section className="py-5">
        <div className="container">
          <div>
            <h1 className="faqfont">FAQs - (SEO)</h1>
          </div>
          <div className="py-5"
            data-aos="fade-right" data-aos-delay="300"
          >
            <div class="accordion" id="accordionExample">
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span class="me-2 toggle-icon"></span>
                    What is SEO and why is it important?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body sms-span">
                    SEO (Search Engine Optimization) is the process of improving
                    a website’s ranking on search engines like{" "}
                    <span className="boldspan">Google </span> to attract organic
                    (free) traffic. It’s important because higher rankings mean
                    more visibility, credibility, and potential customers for
                    your business.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How long does SEO take to show results?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    SEO is a long-term strategy. Most businesses see noticeable
                    improvements within{" "}
                    <span className="boldspan">3 to 6 months,</span> but
                    significant results can take{" "}
                    <span className="boldspan"> 6 to 12 months,</span> depending
                    on competition, website optimization, and content strategy.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What are the main types of SEO?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>
                        <span className="boldspan"> On-Page SEO</span> –
                        Optimizing website content, meta tags, headings, and
                        keywords.
                      </li>
                      <li>
                        <span className="boldspan">Off-Page SEO</span> –
                        Building backlinks and social media signals to improve
                        domain authority.
                      </li>
                      <li>
                        <span className="boldspan">Technical SEO</span> –
                        Improving site speed, mobile-friendliness, structured
                        data, and security
                      </li>
                      <li>
                        <span className="boldspan">Local SEO</span> – Optimizing
                        for local searches, Google My Business, and customer
                        reviews.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What’s the difference between SEO and PPC?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>
                        <span className="boldspan">SEO</span> (Search Engine
                        Optimization) focuses on{" "}
                        <span className="boldspan">organic </span>(free)
                        rankings but takes time to show results.
                      </li>
                      <li>
                        <span className="boldspan"> PPC</span> (Pay-Per-Click)
                        ads provide <span className="boldspan">instant</span>{" "}
                        visibility, but you pay for every click.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFive">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Why isn’t my website ranking on Google?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>New website (takes time to rank)</li>
                      <li>Poor keyword strategy or lack of content</li>
                      <li>Weak backlinks and low domain authority</li>
                      <li>
                        Technical SEO issues (slow loading speed, indexing
                        errors)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingSix">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How do backlinks help with SEO?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Backlinks (links from other websites to yours) act as a{" "}
                    <span className="boldspan">vote of confidence</span> for
                    Google. The more
                    <span className="boldspan"> high-quality</span> backlinks
                    you have, the <span className="boldspan">higher </span>your
                    chances of ranking better.
                  </div>
                </div>
              </div>
              {showAll && (
                <>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSeven">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Does social media help with SEO?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Social media doesn’t directly impact SEO rankings, but
                        it{" "}
                        <span className="boldspan">
                          boosts brand awareness, engagement, and content
                          sharing,
                        </span>{" "}
                        which can indirectly improve traffic and authority.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingEight">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        <span class="me-3 toggle-icon"></span>
                        What are SEO ads?
                      </button>
                    </h2>
                    <div
                      id="collapseEight"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        SEO ads, also known as Search Engine Optimization ads,
                        are a form of online advertising that uses targeted
                        keywords to reach users who are searching for specific
                        products or services.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingNine">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseNine"
                        aria-expanded="false"
                        aria-controls="collapseNine"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How do I measure SEO success?
                      </button>
                    </h2>
                    <div
                      id="collapseNine"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingNine"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            <span className="boldspan">Organic traffic</span>{" "}
                            (visitors from search engines)
                          </li>
                          <li>
                            <span className="boldspan"> Keyword rankings</span>{" "}
                            (position on Google)
                          </li>
                          <li>
                            <span className="boldspan">
                              {" "}
                              Click-through rate{" "}
                            </span>
                            (CTR) (how many users click on your site)
                          </li>
                          <li>
                            <span className="boldspan"> Backlinks </span>
                            (quality and number of links)
                          </li>
                          <li>
                            <span className="boldspan"> Conversions</span>{" "}
                            (leads or sales generated from SEO)
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default DigitalSeo;
